<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 100%">
                <el-row class="filter-bar" ref="filterBar">
                    <el-select v-model="formDatas.asId" placeholder="请选择商户" style="width: 200px;" size="mini" clearable
                        filterable @change="partserch">
                        <el-option v-for="item in shopList" :key="item.asId" :label="item.asName"
                            :value="item.asId"></el-option>
                    </el-select>
                    <el-select size="mini" v-model="formDatas.ascId" clearable @change="cityChange"
                        placeholder="请选择商户城市" style="width: 130px">
                        <el-option v-for="item in getAjefShopCityList_data" :key="item.ascId" :label="item.ascName"
                            :value="item.ascId"></el-option>
                    </el-select>
                    <el-select size="mini" v-if="formDatas.ascId" v-model="formDatas.ascdId" clearable
                        @change="partserch" placeholder="请选择商户区县" style="width: 130px">
                        <el-option v-for="item in getAjefShopCityDistrictList_data" :key="item.ascdId"
                            :label="item.ascdName" :value="item.ascdId"></el-option>
                    </el-select>
                    <el-select v-model="formDatas.billShareType" placeholder="请选择关联类型" style="width: 150px;" size="mini"
                        clearable @change="partserch">
                        <el-option label="普通" :value="1"></el-option>
                        <el-option label="商超" :value="2"></el-option>
                        <el-option label="体检" :value="3"></el-option>
                        <el-option label="北国" :value="0"></el-option>
                    </el-select>
                    <el-select v-model="formDatas.acrsrsStatus" placeholder="请选择上架状态" style="width: 150px;" size="mini"
                        clearable @change="partserch">
                        <el-option label="未上架" :value="1"></el-option>
                        <el-option label="已上架" :value="2"></el-option>
                    </el-select>
                     <el-select v-model="formDatas.acrsrsStatusCheck" placeholder="请选择审核状态" style="width: 150px;" size="mini"
                        clearable @change="partserch">
                        <el-option label="待提交" :value="1"></el-option>
                        <el-option label="待审核" :value="2"></el-option>
                        <el-option label="审核通过" :value="3"></el-option>
                        <el-option label="审核驳回" :value="4"></el-option>
                    </el-select>
                    <div class="filter-actions">
          <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
                        style="">搜索</el-button>
                    <el-button type="warning" size="mini" style=""
                        @click="handleExport">导出</el-button>
          </div>
        </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss" v-loading="tableLoading" element-loading-background="rgba(255, 255, 255, 0.9)"
                element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading" custom-class="table-loading">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" style="width: 100%" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
        </div>
        <!-- 查看详情对话框 -->
        <el-dialog title="规格图片详情" :visible.sync="imageDetailVisible" width="700px" :close-on-click-modal="false">
            <div v-if="currentRow" style="margin-bottom: 15px;">
                <span style="font-weight: bold;">规格名称：</span>
                <span>{{ currentRow.specsName }}</span>
                <span style="margin-left: 20px; font-weight: bold;">规格编码：</span>
                <span>{{ currentRow.specsSku }}</span>
            </div>
            <el-table :data="currentImages" border style="width: 100%" max-height="400">
                <el-table-column prop="index" label="序号" width="80" align="center">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column prop="url" label="图片" align="center">
                    <template slot-scope="scope">
                        <el-image :src="scope.row.url"
                            style="width: 80px; height: 80px; object-fit: cover; cursor: pointer; border-radius: 4px;"
                            :preview-src-list="currentImageList" fit="cover" />
                    </template>
                </el-table-column>
                <el-table-column prop="url" label="图片地址" align="center">
                    <template slot-scope="scope">
                        <el-tooltip :content="scope.row.url" placement="top" :open-delay="500">
                            <span
                                style="color: #409EFF; cursor: pointer; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; display: block; max-width: 300px;">
                                {{ scope.row.url }}
                            </span>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button @click="imageDetailVisible = false">关 闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { calcTableHeight } from "../../utils/tableHeight.js";
import qs from 'qs';
import axios from 'axios';
import config from '../../api/env.js';
import { getAjefShopCityList, getAjefShopCityDistrictList, getAjefCertificateRecordSpecsRelationShopList, getAjefShopListQuick, updateAjefCertificateRecordSpecsRelationShopUp, updateAjefCertificateRecordSpecsRelationShopDown, exportAjefCertificateRecordSpecsRelationShop, updateAjefShopDisableHeXiao, updateAjefShopEnableHeXiao, updateAjefCertificateRecordSpecsRelationShopCheck } from "../../api/api";
export default {
    name: "SpecsRelationShop",
    data() {
        return {
            getAjefShopCityList_data: [],
            getAjefShopCityDistrictList_data: [],
            tableLoading: false,
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            shopList: [],
            loadings: null,
            imageDetailVisible: false,
            currentRow: null,
            currentImages: [],
            currentImageList: [],
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,

            columns: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "asName",
                    key: "asName",
                    title: "商户名称",
                    align: "center",
                    width: 200,
                },
                {
                    field: "specsName",
                    key: "specsName",
                    title: "规格名称",
                    align: "center",
                    width: 150,
                },
                {
                    field: "specsSku",
                    key: "specsSku",
                    title: "规格编码",
                    align: "center",
                    width: 120,
                },
                {
                    field: "acrAmount",
                    key: "acrAmount",
                    title: "劵面金额",
                    align: "center",
                    width: 100,
                },
                {
                    field: "relationName",
                    key: "relationName",
                    title: "规格描述",
                    align: "center",
                    width: 150,
                },
                {
                    field: "relationImage",
                    key: "relationImage",
                    title: "规格图片",
                    align: "center",
                    width: 120,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        if (row.relationImage) {
                            const images = row.relationImage.split(',').filter(img => img);
                            if (images.length > 0) {
                                return (
                                    <el-button
                                        size="mini"
                                        type="text"
                                        style="color: #409EFF"
                                        on-click={() => this.showImageDetail(row)}
                                    >
                                        查看图片详情
                                    </el-button>
                                );
                            }
                            return '';
                        } else {
                            return '';
                        }
                    },
                },
                {
                    field: "relationNamePreparing",
                    key: "relationNamePreparing",
                    title: "描述-待审核",
                    align: "center",
                    width: 150,
                },
                {
                    field: "relationImagePreparing",
                    key: "relationImagePreparing",
                    title: "图片-待审核",
                    align: "center",
                    width: 120,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        if (row.relationImagePreparing) {
                            const images = row.relationImagePreparing.split(',').filter(img => img);
                            if (images.length > 0) {
                                return (
                                    <el-button
                                        size="mini"
                                        type="text"
                                        style="color: #409EFF"
                                        on-click={() => this.showImageDetailPreparing(row)}
                                    >
                                        查看图片详情
                                    </el-button>
                                );
                            }
                            return '';
                        } else {
                            return '';
                        }
                    },
                },
                {
                    field: "acrsrsStatusCheck",
                    key: "acrsrsStatusCheck",
                    title: "审核状态",
                    align: "center",
                    width: 100,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        if (row.acrsrsStatusCheck == 1) {
                            return <el-tag size="mini" type="info">待提交</el-tag>
                        } else if (row.acrsrsStatusCheck == 2) {
                            return <el-tag size="mini" type="warning">待审核</el-tag>
                        } else if (row.acrsrsStatusCheck == 3) {
                            return <el-tag size="mini" type="success">审核通过</el-tag>
                        } else if (row.acrsrsStatusCheck == 4) {
                            return <el-tag size="mini" type="danger">驳回审核</el-tag>
                        } else {
                            return ''
                        }
                    },
                },
                {
                    field: "acrsrsStatus",
                    key: "acrsrsStatus",
                    title: "上架状态",
                    align: "center",
                    width: 100,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        if (row.acrsrsStatus == 1) {
                            return <el-tag size="mini" type="info">未上架</el-tag>
                        } else if (row.acrsrsStatus == 2) {
                            return <el-tag size="mini" type="success">已上架</el-tag>
                        } else {
                            return ''
                        }
                    },
                },
                {
                    field: "asHexiaoStatus",
                    key: "asHexiaoStatus",
                    title: "核销状态",
                    align: "center",
                    width: 100,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.asHexiaoStatus == 1 ? <el-tag size="mini" type="success">允许核销</el-tag> :
                                        row.asHexiaoStatus == 2 ? <el-tag size="mini" type="danger">禁用核销</el-tag> :
                                            ''
                                }
                            </span>
                        );
                    },
                },
                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 320,
                    align: "center",
                    fixed: "right",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.acrsrsStatusCheck == 2 &&
                                    <span>
                                        <el-button
                                            size="mini"
                                            type="text"
                                            style="color: #67c23a"
                                            on-click={() => this.handleCheckPass(row)}
                                        >
                                            审核通过
                                        </el-button>
                                        <el-button
                                            size="mini"
                                            type="text"
                                            style="color: #f56c6c"
                                            on-click={() => this.handleCheckReject(row)}
                                        >
                                            审核驳回
                                        </el-button>
                                    </span>
                                }
                                {
                                    row.acrsrsStatus == 1 ?
                                        <el-button
                                            size="mini"
                                            type="text"
                                            style="color: green"
                                            on-click={() => this.handleUp(row)}
                                        >
                                            上架
                                        </el-button> :
                                        <el-button
                                            size="mini"
                                            type="text"
                                            style="color: orange"
                                            on-click={() => this.handleDown(row)}
                                        >
                                            下架
                                        </el-button>
                                }
                                {
                                    row.asHexiaoStatus == 2 ?
                                        <el-button
                                            size="mini"
                                            type="text"
                                            on-click={() => this.handleEnableHeXiao(row)}
                                        >
                                            解禁商户核销
                                        </el-button> : <el-button
                                            size="mini"
                                            type="text"
                                            style="color: red"
                                            on-click={() => this.handleDisableHeXiao(row)}
                                        >
                                            禁用商户核销
                                        </el-button>
                                }
                            </span>
                        );
                    },
                },
            ],
            tableData: [],
            post: null,
            formDatas: {
                currentPage: 1,
                pageSize: 10,
                asId: '',
                billShareType: '',
                acrsrsStatus: '',
            },
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = calcTableHeight(this, this.windheight, 140);
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = calcTableHeight(this, val, 140);
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = calcTableHeight(this, this.windheight, 140);
        this.getShopList();
        this.getList();
        getAjefShopCityList({ pageSize: 0 }).then(res => {
            this.getAjefShopCityList_data = res.data
        })
    },
    mounted() { },
    methods: {
        // 城市选择变化时加载区县
        cityChange(ascId) {
            this.formDatas.ascdId = '';
            this.getAjefShopCityDistrictList_data = [];
            if (ascId) {
                this.loadDistrictList(ascId);
            }
            this.partserch();
        },
        // 加载区县列表
        loadDistrictList(ascId) {
            const ascIdParam = ascId || this.formDatas.ascId;
            if (ascIdParam) {
                getAjefShopCityDistrictList({ ascId: ascIdParam }).then(res => {
                    this.getAjefShopCityDistrictList_data = res.data || [];
                });
            }
        },
        handleExport() {
            var s = qs.stringify(this.formDatas);
            this.openLoading()
            var that = this
            axios({
                method: 'post',
                url: config.baseURL + '/ajef-certificate-record-specs-relation-shop/exportAjefCertificateRecordSpecsRelationShop',
                data: s,
                // withCredentials: true,
                timeout: 1200000,
                responseType: 'arraybuffer',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    'useref': window.localStorage.getItem('Qy_token')
                }
            }).then(function (res) {
                if (res.data) {
                    that.loadings.close()
                    let a = document.createElement('a');
                    //ArrayBuffer 转为 Blob
                    let blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel"
                    });
                    let objectUrl = URL.createObjectURL(blob);
                    a.setAttribute("href", objectUrl);
                    a.setAttribute("download", '商户规格关联.xlsx');
                    a.click();
                    that.$message({
                        message: "成功",
                        type: "success"
                    });

                }
            })
        },

        getDateCode() {
            var date = new Date();
            var code = date.getFullYear() + "" + (date.getMonth() + 1 > 9 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)) + "" + (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) + "" + (date.getHours() > 9 ? date.getHours() : "0" + date.getHours()) + "" + (date.getMinutes() > 9 ? date.getMinutes() : "0" + date.getMinutes()) + "" + (date.getSeconds() > 9 ? date.getSeconds() : "0" + date.getSeconds());
            return code;
        },
        openLoading() {
            this.loadings = this.$loading({
                lock: true,
                text: "导出中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        closeLoading() {
            if (this.loadings) {
                this.loadings.close();
            }
        },
        showImageDetail(row) {
            const images = row.relationImage ? row.relationImage.split(',').filter(img => img) : [];
            this.currentRow = row;
            this.currentImages = images.map(url => ({ url }));
            this.currentImageList = images;
            this.imageDetailVisible = true;
        },
        showImageDetailPreparing(row) {
            const images = row.relationImagePreparing ? row.relationImagePreparing.split(',').filter(img => img) : [];
            this.currentRow = row;
            this.currentImages = images.map(url => ({ url }));
            this.currentImageList = images;
            this.imageDetailVisible = true;
        },
        getShopList() {
            getAjefShopListQuick({ currentPage: 1, pageSize: 0, asStatus: 3 }).then(res => {
                this.shopList = res.data || [];
            });
        },
        handleUp(row) {
            this.$confirm("是否确定要上架, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                updateAjefCertificateRecordSpecsRelationShopUp({ acrsrsId: row.acrsrsId }).then(res => {
                    if (res.data) {
                        this.$message({ type: "success", message: "上架成功!" });
                        this.getList();
                    }
                });
            }).catch(() => {
                this.$message({ type: "info", message: "已取消" });
            });
        },
        handleDown(row) {
            this.$confirm("是否确定要下架, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                updateAjefCertificateRecordSpecsRelationShopDown({ acrsrsId: row.acrsrsId }).then(res => {
                    if (res.data) {
                        this.$message({ type: "success", message: "下架成功!" });
                        this.getList();
                    }
                });
            }).catch(() => {
                this.$message({ type: "info", message: "已取消" });
            });
        },
        // 审核通过
        handleCheckPass(row) {
            this.$confirm("确认审核通过该规格？通过后将自动上架。", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                updateAjefCertificateRecordSpecsRelationShopCheck({ acrsrsId: row.acrsrsId, acrsrsStatusCheck: 3 }).then(res => {
                    if (res.status == 200) {
                        this.$message({ type: "success", message: "审核通过!" });
                        this.getList();
                    }
                });
            }).catch(() => {
                this.$message({ type: "info", message: "已取消" });
            });
        },
        // 审核驳回
        handleCheckReject(row) {
            this.$confirm("确认驳回该规格审核？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                updateAjefCertificateRecordSpecsRelationShopCheck({ acrsrsId: row.acrsrsId, acrsrsStatusCheck: 4 }).then(res => {
                    if (res.status == 200) {
                        this.$message({ type: "success", message: "已驳回!" });
                        this.getList();
                    }
                });
            }).catch(() => {
                this.$message({ type: "info", message: "已取消" });
            });
        },
        handleDisableHeXiao(row) {
            this.$prompt("请输入禁用原因?", "确定要禁用核销吗", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then((value) => {
                    updateAjefShopDisableHeXiao({ asId: row.asId, asDisableHeXiaoDes: value.value }).then(res => {
                        if (res.status == 200) {
                            this.$message({
                                type: "success",
                                message: "禁用成功!",
                            });
                            this.partserch();
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEnableHeXiao(row) {
            this.$prompt("请输入启用原因?", "确定要启用核销吗", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then((value) => {
                    updateAjefShopEnableHeXiao({ asId: row.asId, asDisableHeXiaoDes: value.value }).then(res => {
                        if (res.status == 200) {
                            this.$message({
                                type: "success",
                                message: "启用成功!",
                            });
                            this.partserch();
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        pageSizeChange(pageSize) {
            this.formDatas.pageSize = pageSize;
            this.partserch();
        },
        pageNumberChange(pageIndex) {
            this.formDatas.currentPage = pageIndex;
            this.tableLoading = true;
            getAjefCertificateRecordSpecsRelationShopList(this.formDatas).then((res) => {
                this.tableLoading = false;
                this.tableData = res.data;
                this.totalCount = res.total;
            }).catch(() => {
                this.tableLoading = false;
            });
        },
        partserch() {
            this.formDatas.currentPage = 1;
            this.tableLoading = true;
            getAjefCertificateRecordSpecsRelationShopList(this.formDatas).then((res) => {
                this.tableLoading = false;
                this.tableData = res.data;
                this.totalCount = res.total;
            }).catch(() => {
                this.tableLoading = false;
            });
        },
        getList() {
            this.tableLoading = true;
            getAjefCertificateRecordSpecsRelationShopList(this.formDatas).then((res) => {
                this.tableLoading = false;
                this.tableData = res.data;
                this.totalCount = res.total;
            }).catch(() => {
                this.tableLoading = false;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>
